import { render, staticRenderFns } from "./grafica2.vue?vue&type=template&id=18c836d1&"
import script from "./grafica2.vue?vue&type=script&lang=js&"
export * from "./grafica2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports